const MEMBER_WALLET_CHARGE_REQUEST = 'MEMBER_WALLET_CHARGE_REQUEST';
const MEMBER_WALLET_CHARGE_SUCCESS = 'MEMBER_WALLET_CHARGE_SUCCESS';
const MEMBER_WALLET_CHARGE_ERROR = 'MEMBER_WALLET_CHARGE_ERROR';

const MEMBER_PAYMENT_WITH_TOKENS_REQUEST = 'MEMBER_PAYMENT_WITH_TOKENS_REQUEST';
const MEMBER_PAYMENT_WITH_TOKENS_SUCCESS = 'MEMBER_PAYMENT_WITH_TOKENS_SUCCESS';
const MEMBER_PAYMENT_WITH_TOKENS_ERROR = 'MEMBER_PAYMENT_WITH_TOKENS_ERROR';

import * as backend from 'backend-helpers/memberWalletCharge';

const initState = {
    payment: false
};

export default function memberWalletCharge(state = initState, action) {

    if (action.type === MEMBER_WALLET_CHARGE_SUCCESS) {
        const { status } = action.result.data;

        return {
            ...state,
            ...action.result.data
        }
    }

    if (action.type === MEMBER_PAYMENT_WITH_TOKENS_SUCCESS) {
        const { status } = action.result.data;

        const payment = !state.payment;

        return {
            ...state,
            ...action.result.data,
            payment
        }
    }

    return state;
}

export function getMemberWalletCharge(params = {}) {
    return {
        types: [MEMBER_WALLET_CHARGE_REQUEST, MEMBER_WALLET_CHARGE_SUCCESS, MEMBER_WALLET_CHARGE_ERROR],
        promise: backend.getMemberWalletCharge(params)
    }
}

export function paymentWithTokens(params = {}) {
    return {
        types: [MEMBER_PAYMENT_WITH_TOKENS_REQUEST, MEMBER_PAYMENT_WITH_TOKENS_SUCCESS, MEMBER_PAYMENT_WITH_TOKENS_ERROR],
        promise: backend.paymentWithTokens(params)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberWalletCharge.js